// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f73Xdc9lbQaDTHTGaL20 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Jgy_eBc9TB18zQFEIAJx {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: stretch;
}

/* --- country dropdown --- */
.oLKB0rvNvg2zY6UBhkTu {
  position: relative;
  flex: 0 0 auto;
}

.zRWNQKQm49VrpFdfzD5A {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 100%;
  padding: 0.5rem 0.6rem;
  border-radius: 0.25rem;
  border: 1px solid #D9D9D9;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10);
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.75);
  box-sizing: border-box;
}

.zRWNQKQm49VrpFdfzD5A:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.TbTApnUkDP9utwE7buOp {
  width: 1.25rem;
  height: 0.9375rem; /* 4:3 ratio */
  border-radius: 2px;
  flex: 0 0 auto;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.PackYXSC8f81nmpzCAlO {
  font-variant-numeric: tabular-nums;
}

.vPt8S_5cgzUVDchY3196 {
  width: 0;
  height: 0;
  border-left: 0.3rem solid transparent;
  border-right: 0.3rem solid transparent;
  border-top: 0.35rem solid rgba(0, 0, 0, 0.45);
  margin-left: 0.15rem;
}

.QrjlobdiMLBXfb8ikXfA {
  position: absolute;
  z-index: 20;
  top: calc(100% + 0.25rem);
  left: 0;
  width: 18rem;
  max-width: 80vw;
  background: #FFF;
  border: 1px solid #D9D9D9;
  border-radius: 0.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.GGoQNSh4c7BJYT10UYnV {
  width: 100%;
}

.TQ0zpvsTXXS80_jrUru7 {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 15rem;
  overflow-y: auto;
}

.aCDmOi0Hj0x_PPl6tjwf {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.8);
}

.MMmraRuKKM2fptGBBNYu {
  background: #F3F4FF;
}

.MUV4xVcTC6P08uaE1u3v {
  font-weight: 600;
}

.YzXQnqckIjkloaRupSCk {
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.svmWIUEKPYKqzgYbKwg8 {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.5);
  font-variant-numeric: tabular-nums;
}

.gXfSKmReTjJZOkCo6MJ3 {
  padding: 0.5rem;
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.9rem;
  text-align: center;
}

.b_LvTCaepFBihnhwsSR7 {
  flex: 1 1 auto;
  min-width: 0;
}

.f73Xdc9lbQaDTHTGaL20:has(> .DbMQCZwgkY32n3l1Aw1w) .zRWNQKQm49VrpFdfzD5A,
.f73Xdc9lbQaDTHTGaL20:has(> .DbMQCZwgkY32n3l1Aw1w) .b_LvTCaepFBihnhwsSR7 {
  border-color: #F24C27;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/PhoneInput/PhoneInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB,EAAE,cAAc;EACjC,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,sCAAsC;EACtC,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n/* --- country dropdown --- */\n.country {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.countryTrigger {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  height: 100%;\n  padding: 0.5rem 0.6rem;\n  border-radius: 0.25rem;\n  border: 1px solid #D9D9D9;\n  background: #FFF;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10);\n  cursor: pointer;\n  font-family: Inter, sans-serif;\n  font-size: 1rem;\n  color: rgba(0, 0, 0, 0.75);\n  box-sizing: border-box;\n}\n\n.countryTrigger:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.flag {\n  width: 1.25rem;\n  height: 0.9375rem; /* 4:3 ratio */\n  border-radius: 2px;\n  flex: 0 0 auto;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.dialCode {\n  font-variant-numeric: tabular-nums;\n}\n\n.caret {\n  width: 0;\n  height: 0;\n  border-left: 0.3rem solid transparent;\n  border-right: 0.3rem solid transparent;\n  border-top: 0.35rem solid rgba(0, 0, 0, 0.45);\n  margin-left: 0.15rem;\n}\n\n.panel {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 0.25rem);\n  left: 0;\n  width: 18rem;\n  max-width: 80vw;\n  background: #FFF;\n  border: 1px solid #D9D9D9;\n  border-radius: 0.5rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.search {\n  width: 100%;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 15rem;\n  overflow-y: auto;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.optionActive {\n  background: #F3F4FF;\n}\n\n.optionSelected {\n  font-weight: 600;\n}\n\n.optionName {\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.optionCode {\n  flex: 0 0 auto;\n  color: rgba(0, 0, 0, 0.5);\n  font-variant-numeric: tabular-nums;\n}\n\n.empty {\n  padding: 0.5rem;\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.numberInput {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.root:has(> .error) .countryTrigger,\n.root:has(> .error) .numberInput {\n  border-color: #F24C27;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `f73Xdc9lbQaDTHTGaL20`,
	"row": `Jgy_eBc9TB18zQFEIAJx`,
	"country": `oLKB0rvNvg2zY6UBhkTu`,
	"countryTrigger": `zRWNQKQm49VrpFdfzD5A`,
	"flag": `TbTApnUkDP9utwE7buOp`,
	"dialCode": `PackYXSC8f81nmpzCAlO`,
	"caret": `vPt8S_5cgzUVDchY3196`,
	"panel": `QrjlobdiMLBXfb8ikXfA`,
	"search": `GGoQNSh4c7BJYT10UYnV`,
	"list": `TQ0zpvsTXXS80_jrUru7`,
	"option": `aCDmOi0Hj0x_PPl6tjwf`,
	"optionActive": `MMmraRuKKM2fptGBBNYu`,
	"optionSelected": `MUV4xVcTC6P08uaE1u3v`,
	"optionName": `YzXQnqckIjkloaRupSCk`,
	"optionCode": `svmWIUEKPYKqzgYbKwg8`,
	"empty": `gXfSKmReTjJZOkCo6MJ3`,
	"numberInput": `b_LvTCaepFBihnhwsSR7`,
	"error": `DbMQCZwgkY32n3l1Aw1w`
};
export default ___CSS_LOADER_EXPORT___;
